export default __webpack_public_path__ + "static/media/img-3.6e326241.jpg";